import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { RecipesDataService, RecipesColumnsService, CategoriesDataService,ApplicationsDataService } from '../../../services';
import { Recipe, RecipesResult, CategoriesResult } from '../../../interfaces';
import { DialogFilerComponent } from '../../filer/filer.component';
import { environment } from '../../../../../environments/environment';
import { ApplicationsResult } from '../../../interfaces';

@Component({
  selector: 'app-recipe-form',
  templateUrl: './recipe-form.component.html',
  styleUrls: ['./recipe-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class RecipeFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public recipe: Recipe = {};
  public recipeForm: FormGroup = new FormGroup({});
  public recipes: Recipe[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'fr';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;
  public uploadUrl: string = '';
  public categories: [] = [];
  private filerDialog: DynamicDialogRef = new DynamicDialogRef();
  selectedFile: File | null;
  formData = new FormData();
  public application: any;
  public applications: any;

  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private recipesDataService: RecipesDataService,
    public recipesColumnsService: RecipesColumnsService,
    public categoriesDataService: CategoriesDataService,
    public applicationsDataService: ApplicationsDataService


  ) {
    this.selectedFile = null; // Initialize it to a default value, such as null

  }

  ngOnInit(): void {
    console.log('ngOnInit', 'RecipeFormComponent');
    this.getCategories();
    this.getapplications();

    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Recipe - Edit');
        this.getRecipe(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.recipe !== 'undefined') {
      this.recipe = this.dynamicDialogConfig.data.recipe;
    }
    if (typeof this.recipe.id === 'undefined' || this.recipe.id === null) {
      this.recipe.id = null;
     
    }
    this.getRecipes();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'RecipeFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'RecipeFormComponent');
  }

  getRecipe(id: number): void {
    this.isLoading = true;
    this.recipesDataService.getRecipe(id).subscribe((response: Recipe|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.recipe = response;
        this.prepareFrom();
      }
    });
  }

  getRecipes(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.recipes !== 'undefined' && this.dynamicDialogConfig.data.recipes.length > 0) {
      this.recipes = this.dynamicDialogConfig.data.recipes;
      return;
    }
    this.recipesDataService.getRecipes(this.parameters).subscribe((response: RecipesResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.recipes = response.results;
      }
    });
  }
  getCategories(){
    this.categoriesDataService.getCategories().subscribe((response: CategoriesResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.categories = response.success.data;
      }
    }, (error: any) => {;
     
    });
  }

  
  prepareFrom(): void {
    this.recipeForm = new FormGroup({
      title: new FormControl(this.recipe.title, [Validators.required, ]),
      titleAr: new FormControl(this.recipe.titleAr, []),
      titleFr: new FormControl(this.recipe.titleFr, []),
      imagePath: new FormControl(this.recipe.imagePath, []),
      description: new FormControl(this.recipe.description, [Validators.required, ]),
      descriptionAr: new FormControl(this.recipe.descriptionAr, []),
      descriptionFr: new FormControl(this.recipe.descriptionFr, []),
      duration: new FormControl(this.recipe.duration, []),
      proteins: new FormControl(this.recipe.proteins, []),
      carbs: new FormControl(this.recipe.carbs, []),
      calories: new FormControl(this.recipe.calories, []),
      application: new FormControl(this.application, [Validators.required,]),
      isActive: new FormControl(this.recipe.isActive, [Validators.required, ]),
      id: new FormControl(this.recipe.id, []),
      category: new FormControl((typeof this.recipe.category === 'number') ? this.recipe.category : this.recipe.category?.id, [Validators.required, ]),
    });

  }

  list() {
    this.router.navigate(['/recipes']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.recipeForm.controls).forEach((field: any) => {
        const control = this.recipeForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    this.saveData(redirect);
    // if (!this.recipeForm.valid) {
    //   this.showErrors();
    // } else {
    //   this.saveData(redirect);
    // }
  }

  saveData(redirect: boolean) {
    this.recipe = this.recipeForm.value;
    this.disableSubmit = true;
  
    const formData = new FormData();
    formData.append('title', this.recipeForm.value.title || '');
    formData.append('titleFr', this.recipeForm.value.titleFr || '');
    formData.append('titleAr', this.recipeForm.value.titleAr || '');
    formData.append('description', this.recipeForm.value.description || '');
    formData.append('descriptionFr', this.recipeForm.value.descriptionFr || '');
    formData.append('descriptionAr', this.recipeForm.value.descriptionAr || '');
    formData.append('duration', this.recipeForm.value.duration || '');
    formData.append('proteins', this.recipeForm.value.proteins || '');
    formData.append('calories', this.recipeForm.value.calories || '');
    formData.append('carbs', this.recipeForm.value.carbs || '');
    formData.append('category', this.recipeForm.value.category || '');
  
    if (this.selectedFile) {
      formData.append('picture', this.selectedFile);
    }
  
    this.recipesDataService.addRecipeWithFile(formData).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: 'Success', detail: 'Recipe created successfully'});
      if (redirect) this.list();
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: 'Error', detail: 'Recipe not created'});
    });
  }
  

  add(redirect: boolean) {
    this.recipesDataService.updateRecipe(this.recipe).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('RECIPEUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('RECIPENOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.recipesDataService.addRecipe(this.recipe).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('RECIPECREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('RECIPENOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

  openFilerDialog(field: string): void {
    console.log('field', field)
    let url = '';
    const control = this.recipeForm.get(field);
    if (control !== null) {
      url = control.value;
    }
    this.filerDialog = this.dialogService.open(DialogFilerComponent, {
      header: '', // this.translate.instant('FILEMANAGER'),
      width: '90%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1500,
      data: {
        path: 'recipes',
        field: field,
        url: url,
      },
    });
    this.filerDialog.onClose.subscribe((response: any) => {
      console.log('responsefilerDialog', response)
      if (response && response.selected) {
        const control = this.recipeForm.get(field);
        if (control !== null) {
          control.setValue(response.selected.webPath);
        }
      }
    });
  }

  openFilerMultiDialog(field: string): void {
    this.uploadUrl = `${environment.apiUrl}filer/upload`;
    console.log('field', field)
    let url = '';
    const control = this.recipeForm.get(field);
    if (control !== null) {
      url = control.value;
    }
    this.filerDialog = this.dialogService.open(DialogFilerComponent, {
      header: '', // this.translate.instant('FILEMANAGER'),
      width: '90%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1500,
      data: {
        path: 'recipes',
        field: field,
        url: url,
      },
    });
    this.filerDialog.onClose.subscribe((response: any) => {
      console.log('responsefilerDialog', JSON.stringify(response), response)
      if (response) {
        const control = this.recipeForm.get(field);
        if (control !== null) {
          if (response.selected != undefined) {
            let url = '[{"url":"' + response.selected.webPath + '"}]';
            control.setValue(url);
          } else {
            control.setValue(JSON.stringify(response));
          }
        }
      }
    });
  }

  uploadPhoto(event: any): void {
    this.selectedFile = event.target.files[0] as File;
    if (this.selectedFile) {
      this.formData.append('picture', this.selectedFile);

    }
  }

  onChange(e: any) {
    this.application = e.value;
  }
  
  getapplications(){
    this.applicationsDataService.getApplications().subscribe((response: ApplicationsResult|any) => {
      if (response !== null) {
        this.applications = response.success.data;
      }
    }, (error: any) => {;
     
    });
  }
}

@Component({
  selector: 'app-recipe-form',
  templateUrl: './recipe-form.component.html',
  styleUrls: ['./recipe-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogRecipeFormComponent extends RecipeFormComponent {
}

